import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  category: string;
  categoryName: string;
  readTime: number;
  publishedAt: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  image,
  category,
  categoryName,
  readTime,
  publishedAt,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={title}
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <Link
            to={`/category/${category}`}
            className="text-xs px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap hover:bg-primary-200 transition-colors"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{readTime} 分钟阅读</span>
        </div>
        <Link to={`/article/${slug}`} className="block">
          <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <time dateTime={publishedAt} className="text-xs text-foreground-400">
          {publishedAt}
        </time>
      </div>
    </article>
  );
}